// extracted by mini-css-extract-plugin
export default {"space30":"index_space30_lkCPm","col_w1000":"index_col_w1000_g4a4O"};